import AddIcon from "@mui/icons-material/Add"; // Make sure you import this
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { memo, useState } from "react";
// import Button from "./components/ui/button";
import {
    Box,
    Button
} from "@mui/material";
import api from "../../axiosConfig";
import ModalComp from "../../themes/Model";
import { Toaster } from "../../components/Toaster";
import LoadingSpinner from "../../components/LoadingSpinner";
import { getUser } from "../../helpers";

function UploadPOModel({
    isModalOpen,
    setIsModalOpen,
    customers
}) {
    const [uploading, setUploading] = useState(false);
    const [uploadCustomer, setUploadCustomer] = useState("");
    // Upload handler
    const handleUpload = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const files = event.target.files;
        const allowedExtensions = ["pdf", "xlsx", "xls", "csv", "jpg", "jpeg", "png"];

        const validFiles = Array.from(files).filter(file => {
            const ext = file.name.split('.').pop().toLowerCase();
            return allowedExtensions.includes(ext);
        });

        // ----- Log upload to ActivityLogs -----
        const user = getUser();  // current logged-in user

        if (validFiles.length === 0) {
            Toaster.warning("Please upload valid .pdf, .xls, .xlsx, .csv, .jpg, .jpeg or .png files.");
            return;
        }

        if (!uploadCustomer) {
            Toaster.warning("Please select a customer before uploading.");
            return;
        }

        setUploading(true);

        try {
            const formData = new FormData();
            validFiles.forEach(file => formData.append("files", file));
            formData.append("customer", uploadCustomer); // Include customer in form
            formData.append("user", user);
            
            const response = await api.post("/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            console.log("Uploaded files:", response.data.uploaded_files);
            Toaster.success("Upload successful!");

        } catch (error) {
            console.error("Upload error:", error);
            Toaster.error("Upload failed.");
        } finally {
            setUploading(false);
        }
    };

    const modalContent = (
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', flexWrap: 'wrap' }}>
            {/* Customer Select */}
            <Box sx={{ minWidth: 200 }}>
                <FormControl fullWidth size="small">
                    <InputLabel id="upload-customer-label">Customer</InputLabel>
                    <Select
                        labelId="upload-customer-label"
                        id="upload-customer-select"
                        value={uploadCustomer}
                        label="Customer"
                        onChange={(e) => setUploadCustomer(e.target.value)}
                    >
                        {customers.map((customer) => (
                            <MenuItem key={customer} value={customer}>
                                {customer}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>

            {/* File Upload */}
            <Box>
                <Box
                    component="label"
                    htmlFor="file-upload"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                        border: "2px dashed var(--id-color)",
                        color: "var(--id-color)",
                        borderRadius: 2,
                        padding: "8px",
                        cursor: "pointer",
                        fontWeight: 500,
                        transition: "0.3s",
                        minWidth: 200,
                        "&:hover": {
                            backgroundColor: "#f0f8ff",
                        },
                    }}
                >
                    <AddIcon />
                    Upload File
                    <input
                        size="small"
                        id="file-upload"
                        type="file"
                        accept=".pdf,.xlsx,.xls,.csv,.jpg,.jpeg,.png"
                        multiple
                        onChange={handleUpload}
                        style={{ display: "none" }}
                    />
                </Box>

                <Box
                    sx={{
                        marginTop: "6px",
                        fontSize: "0.75rem",
                        color: "#6b7280", // subtle grey
                        maxWidth: 220,
                        lineHeight: 1.4,
                    }}
                >
                    Supported file formats: <strong>.pdf, .xls, .xlsx, .csv, .jpg, .jpeg, .png</strong>
                </Box>

                {uploading && (
                    <span style={{ fontSize: "0.875rem", color: "#4b5563", marginTop: "8px", display: "block" }}>
                        <LoadingSpinner /> Uploading...
                    </span>
                )}
            </Box>
        </Box>
    );

    const actionButtons = (
        <Button
            variant="outlined"
            onClick={() => setIsModalOpen(false)}
            style={{ fontSize: "12px", color: "#000", borderColor: "#707070" }}
            size="small"
        >
            Cancel
        </Button>
    );

    return (
        <>
            <ModalComp
                open={isModalOpen}
                handleClose={() => setIsModalOpen(false)}
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        Upload PO Files
                    </span>
                }
                modalContent={modalContent}
                modelButtons={actionButtons}
                datePickerStyle={{ width: "48%", margin: "5px" }}
                themeStyles={{
                    boxStyle: {
                        width: "682px",
                        height: "auto",
                        margin: "auto",
                        marginTop: "80px",
                    },
                    titleStyle: {
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "#000",
                        backgroundColor: "#F4F4F4",
                        padding: "24px",
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                    },
                    fieldStyle: { width: "100%", marginTop: "20px" },
                    actionButtonContainerStyle: {
                        padding: "0 20px 20px 20px",
                    },
                }}
            />
        </>
    )
}

export default memo(UploadPOModel);
